import React, {JSX} from 'react'
import Button, {ButtonProps} from '@mui/material/Button'
import {Tooltip} from '@mui/material'
import {HourglassEmpty} from '@mui/icons-material'
import {css, SerializedStyles} from '@emotion/react'

export interface ButtonWithIconProps extends Omit<ButtonProps, 'children' | 'title'> {
	icon?: JSX.Element
	label?: string
	title?: JSX.Element | string
	loading?: boolean
	children?: never
	hideLabel?: boolean
	iconOnTop?: boolean
	disableInteractive?: boolean // default true
}

const cssButtonBase = css`
	min-height: 40px;
	box-sizing: border-box;
	overflow: hidden;
`
const cssNormalRoot = css`
	display: flex;
	justify-content: center;
	align-items: center;
`
const cssNormalIcon = css`
	display: flex;
	justify-content: center;
	align-items: center;
`
const cssNormalLabel = css`
	margin-top: 2px;
	margin-left: 4px;
	font-size: 11px;
`

const cssIconOnTopButton = css`
	min-width: 0;
	padding: 2px 4px;
`
const cssIconOnTopRoot = css`
	width: 100%;
	display: grid;
	grid-template-columns: min-content;
	align-content: center;
	justify-items: center;
`
const cssIconOnTopIcon = css`
	display: flex;
	justify-content: center;
	min-width: 36px;

	& > svg {
		// material-ui icon
		height: 22px;
		width: 22px;
	}

	& > span.fa {
		// font awesome
		height: 24px;
		width: 24px;
		font-size: 18px;
		display: flex;
		justify-content: center;
		align-items: center;
	}
`
const cssIconOnTopLabel = css`
	font-size: 8px;
	height: 10px;
	text-wrap: nowrap;
`

export const ButtonWithIcon = React.forwardRef<HTMLButtonElement, ButtonWithIconProps>((props, ref) => {
	let {icon, loading, iconOnTop, label, hideLabel, title, disableInteractive = true, ...btnProps} = props
	if (!label || hideLabel) iconOnTop = false
	let cssButton: SerializedStyles | undefined, cssRoot: SerializedStyles, cssIcon: SerializedStyles, cssLabel: SerializedStyles;
	if (iconOnTop) {
		cssButton = cssIconOnTopButton
		cssRoot = cssIconOnTopRoot
		cssIcon = cssIconOnTopIcon
		cssLabel = cssIconOnTopLabel
	} else {
		cssButton = undefined
		cssRoot = cssNormalRoot
		cssIcon = cssNormalIcon
		cssLabel = cssNormalLabel
	}
	const ret = (
		<Button ref={ref} {...btnProps} css={[cssButtonBase, cssButton]} component={'span'}>
			<div css={cssRoot}>
				<div css={cssIcon}>
					{loading && <HourglassEmpty/> || icon}
				</div>
				{!hideLabel && <>
					{!!label && <div css={cssLabel} dangerouslySetInnerHTML={{__html: label}}/>}
				</>}
			</div>
		</Button>
	)
	if (hideLabel && title) {
		title = <>
			<div dangerouslySetInnerHTML={{__html: label || ''}}/>
			<br/>
			<div>{title}</div>
		</>
	}
	if (title) return (
		<Tooltip disableInteractive={disableInteractive} title={title}>
			{ret}
		</Tooltip>
	)
	else return ret;
})